module.exports = __webpack_public_path__ + "static/media/logo-running-room-inverse.222b6707.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-running-room-inverse.svg
// module id = 451
// module chunks = 0